import {Component, computed, input} from '@angular/core';
import {CircleSmallIcon, LucideAngularModule, MarsIcon, VenusAndMarsIcon, VenusIcon} from 'lucide-angular';
import {PersonGender} from '@domain/common/common';

@Component({
  selector: 'app-person-gender-icon',
  imports: [
    LucideAngularModule
  ],
  templateUrl: './person-gender-icon.component.html'
})
export class PersonGenderIconComponent {

  public readonly gender = input.required<PersonGender | null | undefined>();
  public readonly icon = computed(() => {
    const gender = this.gender();
    return gender ? this.icons[gender] : this.noGenderIcon;
  });

  private readonly noGenderIcon = CircleSmallIcon;

  private readonly icons = {
    [PersonGender.Mx]: VenusAndMarsIcon,
    [PersonGender.Mr]: MarsIcon,
    [PersonGender.Ms]: VenusIcon
  };
}
